import { render, staticRenderFns } from "./product_vodafone.vue?vue&type=template&id=bc1c9e9c&scoped=true"
import script from "./product_vodafone.vue?vue&type=script&lang=js"
export * from "./product_vodafone.vue?vue&type=script&lang=js"
import style1 from "./product_vodafone.vue?vue&type=style&index=1&id=bc1c9e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1c9e9c",
  null
  
)

export default component.exports